// @Flow
import cx from 'classnames';
import isEmpty from 'lodash.isempty';
import React, { Component } from 'react';
import WaveSurfer from 'wavesurfer.js';

import uuid from 'uuid/v4';
import { VIDEO } from '../../../../../common/constants/fileTypes';
import { COLOURS } from '../../../../../ui-kit';
import FileTypeIcon from '../../FileTypeIcon';
import ImagePreview from '../../ImagePreview';
import InteractiveOverlay from '../../InteractiveOverlay';
import { parseJSON } from '../../../../../common/utils';

import '../styles/_audio-preview.scss';

const WAVE_CONTAINER_CLASS = 'audio-preview__wave';
















export default class AudioPreview extends Component


{








  // eslint-disable-next-line react/sort-comp
  requiresWaveSurfer = (fn) => (...args) => {
    if (!this._waveSurfer) {
      return null;
    }

    return fn(...args);
  };

  handleWaveSurferAction = this.requiresWaveSurfer(
    (action) => {
      // $FlowFixMe requiresWaveSurfer has the this._waveSurfer check
      this._waveSurfer[action]();
    }
  );

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      playing: false
    };
    this.waveContainerId = `wave-container-${uuid()}`;
    this.waveContainerRef = React.createRef();
    this.resizeObserver = null;
  }

  async componentDidMount() {
    const {
      asset: { assetFiles, metaData, organisationId },
      getBynderAssetDownloadUrl
    } = this.props;

    if (assetFiles.ORIGINAL?.status !== 'UPLOADED') {
      console.warn('AudioPreview: Asset not uploaded yet, skipping audio load');
      this.setState({ isLoading: false });
      return;
    }
    let { sourceUrl } = assetFiles.ORIGINAL;
    const { bynderAssetId, type } = parseJSON(metaData);

    if (bynderAssetId && getBynderAssetDownloadUrl) {
      const { data, error } = await getBynderAssetDownloadUrl({
        bynderAssetId,
        organisationId
      });

      if (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching audio preview', error);
      }

      if (data && data.getBynderAssetDownloadUrl) {
        sourceUrl = data.getBynderAssetDownloadUrl;
      }
    }

    if (!this.waveContainerRef.current) {
      return;
    }

    const wavesurfer = WaveSurfer.create({
      container: `#${this.waveContainerId}`,
      waveColor: COLOURS.grey.athens.bigFat,
      progressColor: COLOURS.cyan.jungleGreen.monkey,
      backend: 'MediaElement',
      barWidth: 2,
      barGap: 0,
      cursorWidth: 2,
      cursorColor: 'rgba(0,0,0,0)',
      height: 'auto'
    });

    this._waveSurfer = wavesurfer;

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

    try {
      if (type === 'audio/wav' && !isIOS) {
        const response = await fetch(sourceUrl);
        const arrayBuffer = await response.arrayBuffer();
        const blob = new Blob([arrayBuffer], { type: 'audio/wav' });
        wavesurfer.loadBlob(blob);
      } else {
        wavesurfer.load(sourceUrl);
      }
    } catch (err) {
      console.error('AudioPreview: Error loading audio', err);
      this.setState({ isLoading: false });
      return;
    }

    wavesurfer.on('ready', this.requiresWaveSurfer(() => {
      this.setState({ isLoading: false });
      if (this.waveContainerRef.current && this.resizeObserver) {
        this.resizeObserver.observe(this.waveContainerRef.current);
      }
    }));

    wavesurfer.on(
      'play',
      this.requiresWaveSurfer(() => {
        this.setState({ playing: true });
      })
    );

    wavesurfer.on(
      'pause',
      this.requiresWaveSurfer(() => {
        this.setState({ playing: false });
      })
    );

    this.resizeObserver = new ResizeObserver(() => {
      this.handleWaveSurferResize();
    });
  }

  componentWillUnmount = this.requiresWaveSurfer(() => {
    this._waveSurfer = null;
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  });

  handleWaveSurferResize = () => {
    if (!this._waveSurfer) return;
    if (!this.waveContainerRef.current) return;

    // $FlowFixMe
    this._waveSurfer.setOptions({
      height: this.waveContainerRef.current.clientHeight || 128
    });
  };


  onPlay = () => {
    this.handleWaveSurferAction('play');
  };

  onPause = () => {
    this.handleWaveSurferAction('pause');
  };

  onRestartPreview = () => {
    this.handleWaveSurferAction('stop');
  };

  getCurrentAudioTime = () => this.handleWaveSurferAction('getCurrentTime');

  renderThumbnail = () => {
    const { audioThumbnail, defaultAudioThumbnail } = this.props;

    if (!isEmpty(audioThumbnail)) {
      return (
        <ImagePreview asset={audioThumbnail} hideFileTypeIcon type={VIDEO} />);

    }

    if (!isEmpty(defaultAudioThumbnail)) {
      return defaultAudioThumbnail;
    }

    return null;
  };

  render() {
    const { hideFileTypeIcon, audioThumbnail } = this.props;
    const { isLoading, playing } = this.state;

    return (
      <InteractiveOverlay
        onPlay={this.onPlay}
        onPause={this.onPause}
        onRestart={this.onRestartPreview}
        playing={playing}
        getCurrentTime={this.getCurrentAudioTime}
        loading={isLoading}>

        {({ overlay, hovering, onMouseOver, onMouseLeave }) =>
        <div
          role="button"
          className={cx('audio-preview', {
            'audio-preview__noPadding': audioThumbnail
          })}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
          onFocus={onMouseOver}
          onBlur={onMouseLeave}
          tabIndex={0}>

            {this.renderThumbnail()}
            {overlay}

            <div
            ref={this.waveContainerRef}
            id={this.waveContainerId}
            className={cx(WAVE_CONTAINER_CLASS, {
              [`${WAVE_CONTAINER_CLASS}--is-visible`]: !isLoading
            })} />

            {!hideFileTypeIcon && (!playing || hovering) ?
          <FileTypeIcon
            className="audio-preview__media-icon"
            name="audio"
            color="white" /> :

          null}
          </div>}

      </InteractiveOverlay>);

  }
}